import React from 'react';
import usePageTitle from '@src/hooks/usePageTitle';
import Content from './Content';
import { Provider } from 'jotai';
import { buildDashboardStore } from '@src/atoms/utils';

const defaultStore = buildDashboardStore();

const SavedDashboards = () => {
  usePageTitle({ text: 'Saved Dashboards' });
  return <Content />;
};

const WrappedSavedDashboards = (props) => {
  const { store = defaultStore }: any = props;
  return (
    <Provider store={store}>
      <SavedDashboards {...props} />
    </Provider>
  );
};
export default WrappedSavedDashboards;
